import { useMemo } from "react";
import { useSelector } from "react-redux";
import Modal from "../../../../components/elements/Modal";
import dayjs from "dayjs";
import Badge from "../../../elements/Badge";

const ReportModal = ({ isOpen, onClose = () => {}, data }) => {
  const { lang } = useSelector((state) => state?.langProvider);

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={onClose}
      title={
        <div className="flex items-center gap-2">
          Report Details
          <Badge type={"info"} label={data?.reason} />
        </div>
      }
      size="xl2"
      titleIcon="fa-regular fa-envelope"
      titleClass="!font-semibold !text-xl !text-deep-purple"
      headerClass="!bg-gray-50 border-b border-gray-200"
      childrenClasses="!bg-white"
      bodyClasses="!p-6"
    >
      <div className="space-y-3">
        <div className="flex items-center gap-2">
          <Badge label={data?.name} />
          <div className="flex items-center gap-1 text-sm text-surface-05">
            <i className="fa-regular fa-envelope"></i>
            {data?.email}
          </div>
        </div>
        <div className="text-sm font-medium">{data?.message}</div>
      </div>
    </Modal>
  );
};

export default ReportModal;
